/**
 * @class TableWidget
 * @description Since this class has no static selector getter, there will be no attempt to instantiate it.
 */
export default class TableWidget {}
